import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimeNgModule } from '@app/shared/primeng/prime-ng.module';
import { LibPipeModule } from '@mynexus/mynexus-ui-lib';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { MessageModule } from 'primeng/message';
import { TabsModule } from 'primeng/tabs';
import { DocumentsAGNotesReportComponent } from '@app/documents/documents-ag-notes-report/documents-ag-notes-report.component';
import { DocumentsListModule } from '@app/documents/documents-list/documents-list.module';
import { DocumentsMoveComponent } from '@app/documents/documents-move/documents-move.component';
import { DocumentsUploadLetterComponent } from '@app/documents/documents-upload-letter/documents-upload-letter.component';
import { DateTimeModalComponent } from '@app/documents/documents-upload/date-time-modal/date-time-modal.component';
import { DocumentsUploadComponent } from '@app/documents/documents-upload/documents-upload.component';
import { DocumentsWidgetComponent } from '@app/documents/documents-widget/documents-widget.component';
import { SendFaxModule } from '@app/documents/send-fax/send-fax.module';
import { SharedLineSelectComponent } from '@app/shared/components/shared-line-select/shared-line-select.component';
import { DocumentUploadSelectComponent } from './documents-upload/document-upload-select/document-upload-select.component';
import { ProductCasesLinesSelectionComponent } from '@app/products/dmepos/components/product-cases-lines-selection/product-cases-lines-selection.component';
import { SharedInfoMessageComponent } from '@app/shared/components/shared-info-message/shared-info-message.component';

import { ServiceLinesSelectionComponent } from '@app/products/pac/components/service-lines-selection/service-lines-selection.component';
import { SharedErrorsMessagesComponent } from '@app/shared/components/shared-errors-messages/shared-errors-messages.component';
import { ServiceLinesTableComponent } from '@app/products/hh/components/services-lines-table/service-lines-table.component';
import { DocumentENotificationComponent } from './document-e-notification/document-e-notification.component';
import { FluidModule } from 'primeng/fluid';
import { AppealsPacketComponent } from './appeals-packet/appeals-packet.component';

@NgModule({
  declarations: [
    DateTimeModalComponent,
    DocumentUploadSelectComponent,
    DocumentsUploadComponent,
    DocumentsWidgetComponent,
    DocumentsMoveComponent,
    DocumentsUploadLetterComponent,
    DocumentsAGNotesReportComponent,
    DocumentENotificationComponent,
    AppealsPacketComponent,
  ],
  imports: [
    CommonModule,
    DocumentsListModule,
    PrimeNgModule,
    DynamicDialogModule,
    FormsModule,
    ReactiveFormsModule,
    TabsModule,
    LibPipeModule,
    SendFaxModule,
    SharedLineSelectComponent,
    MessageModule,
    ProductCasesLinesSelectionComponent,
    SharedInfoMessageComponent,
    SharedErrorsMessagesComponent,
    ServiceLinesSelectionComponent,
    SharedInfoMessageComponent,
    ServiceLinesTableComponent,
    FluidModule,
  ],
  exports: [
    DateTimeModalComponent,
    DocumentUploadSelectComponent,
    DocumentsUploadComponent,
    DocumentsWidgetComponent,
    DocumentsMoveComponent,
    DocumentsUploadLetterComponent,
  ],
})
export class DocumentsModule {}
